import { MarkupElement, MarkupValue } from 'src/api/models/MarkupHtml';
import { cleanNewLines } from './cleanHtmlNewLines';
import { ImageHtmlComponents, structuredImageHtmlComponents } from '../HtmlTagComponents/ImageHtmlComponents';
import {
  ParagraphHtmlComponents,
  structuredParagraphHtmlComponents,
} from '../HtmlTagComponents/ParagraphHtmlComponents';

export type StructuredHtmlData = ParagraphHtmlComponents | ImageHtmlComponents;

// If conflicting filter functions are found, arrange them in order here
const orderedStructuringFunctions = [structuredParagraphHtmlComponents, structuredImageHtmlComponents];

export const structureHtmlData = (contentHtmlAst: (MarkupElement | MarkupValue)[]): StructuredHtmlData[] => {
  // Root level HTML elements are either newlines or elements
  const cleanContentHtmlAst = cleanNewLines(contentHtmlAst) as MarkupElement[];
  const structuredHtmlData = cleanContentHtmlAst.map((htmlAst) => {
    // Using Find should return the first matching function, instead of doing a declarative iteration
    const applicableFunction = orderedStructuringFunctions.find((structureFunction) => structureFunction(htmlAst));

    return applicableFunction && applicableFunction(htmlAst);
  });

  // Non applicable data is filtered out
  return structuredHtmlData.filter((data) => !!data);
};
